import React from 'react'
import {Icon} from '@chakra-ui/react'

const DoubleChevronRightIcon = (props) => {
    return (
        <Icon
            viewBox="0 0 16 16"
            width="16px"
            height="16px"
            flexShrink={0}
            fill="none"
            aria-hidden="true"
            {...props}
        >
            <path
                d="M3.46973 4.13678C3.76262 3.84389 4.23738 3.84389 4.53027 4.13678L7.86328 7.46979C8.15589 7.7627 8.15608 8.23754 7.86328 8.53033L4.53027 11.8643C4.23751 12.1568 3.76256 12.1567 3.46973 11.8643C3.17693 11.5715 3.17713 11.0967 3.46973 10.8038L6.27246 8.00006L3.46973 5.19733C3.17688 4.90448 3.17697 4.42968 3.46973 4.13678ZM8.13574 4.13678C8.42863 3.84389 8.90339 3.84391 9.19629 4.13678L12.5293 7.46979C12.8222 7.76268 12.8222 8.23744 12.5293 8.53033L9.19629 11.8643C8.9034 12.1566 8.42845 12.1568 8.13574 11.8643C7.84307 11.5716 7.84346 11.0967 8.13574 10.8038L10.9385 8.00006L8.13574 5.19733C7.84302 4.90458 7.8433 4.4297 8.13574 4.13678Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default DoubleChevronRightIcon
